import { render, staticRenderFns } from "./leadsDashboardCategorySettings.vue?vue&type=template&id=b08f2482"
import script from "./leadsDashboardCategorySettings.vue?vue&type=script&lang=js"
export * from "./leadsDashboardCategorySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports